import { render, staticRenderFns } from "./AssociatedEntitiesTable.vue?vue&type=template&id=31506bb2&scoped=true"
import script from "./AssociatedEntitiesTable.vue?vue&type=script&lang=js"
export * from "./AssociatedEntitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31506bb2",
  null
  
)

export default component.exports